import React from 'react';
import Sorting from './Sorting';
import { sort } from 'react-icons-kit/fa/sort';
import { Input, TextField, MenuItem } from '@mui/material';
import _ from 'lodash';
import '../css/regokas.css';
import { search } from 'react-icons-kit/icomoon/search';
import Delete from '../images/headericon/Delete.svg';
import Delete1 from '../images/headericon/deletedeactive.svg';
import Success from '../images/Success.svg';
import Error from '../images/Error.svg';
import IntegrationReactSelectNew from './IntegrationReactSelectNew';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    TableSortLabel,
    IconButton,
} from "@mui/material";
import cities from './cities';
import Loader from '../components/loader';
import { connect } from 'react-redux';
import * as ActionTypes from '../actions/types';
import errorText from './../errorText';
import SearchBar from './SearchBar';
import SnackBar from './../containers/SnackBar';
import Style from 'style-it';
import { AiOutlinePlus } from 'react-icons/ai';
import { RxCross2 } from 'react-icons/rx';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { Box } from '@mui/system';
import { is_allowed } from '../utils';

class OfficeLocation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            topHeightModal: '0%',
            okasBoxData: [],
            confirmWindow: false,
            kk: 'asdvhj',
            phone: '',
            name: '',

            email: '',
            officelocation: '',
            error: '',
            nameerror: '',
            namess: '',
            sortedType: '',
            searchValue: '',
            actualdata: [],
            disabledvalue: '',
            classshowofmodal: false,
            successmsgmodaldata: localStorage.getItem('dataadded'),
            showmodels: '',
            searchbar: '',
            opensearch1: 0,
            loader: '',
            currentPage: 1,
            todosPerPage: 10,
            statuson: false, statustw: false, statusth: false,
            statusfo: false, statusfi: false, statussi: false,
            statusse: false, statusei: false, statusni: false,
            statuste: false,
            indianCityWithState: [],
            showError: false,
            otherlocation: '',
            snackbarActive: false,
            snackbarMessage: '',
        };
        // this.handleClickpage = this.handleClickpage.bind(this);
    }

    confirmWindowClose = () => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            confirmWindow: false
        })
    }

    onSelectChange = (operationMode, valueSelect) => {
        if (operationMode === 'rating') {
            this.setState({
                SiRating: valueSelect.value,
                errorMessage: []
            })
        }
        if (operationMode === 'relationStat') {
            this.setState({
                SiRelationStat: valueSelect.value,
                errorMessage: []
            })
        }
        if (operationMode === 'siArea') {
            this.setState({
                SiArea: valueSelect.value,
                errorMessage: [],
                officelocation: valueSelect.value,
                officelocationerror: false,
                error: false,
            })
        }
    }

    opensearch = (data) => {
        if (data == 0)
            this.setState({
                opensearch1: 1,
            });
        else
            this.setState({
                opensearch1: 0,
            });
        // console.log(this.state.opensearch1)
    }

    componentWillMount() {
        // console.log(TopHeader.state.opensearch) 
    }

    componentDidMount() {
        this.getallrealdata();
        let cityNew = [];
        cities.map((e) => {
            let newCity = {
                "label": `${e.city} , ${e.state}`,
                "value": `${e.city} , ${e.state}`
            }
            cityNew.push(newCity);
        })
        this.setState({
            indianCityWithState: cityNew
        }, () => console.log(this.state.indianCityWithState))
    }

    getcitydata = () => {
        let cityNew = [];
        cities.map((e) => {
            let newCity = {
                "label": `${e.city}, ${e.state}`,
                "value": `${e.city}, ${e.state}`
            }
            cityNew.push(newCity);
        })
        this.setState({
            indianCityWithState: cityNew
        }, () => console.log(this.state.indianCityWithState))
    }

    //------------------------------------------------ error msg function start--------------------------------------------------------
    errormsg = () => {
        setTimeout(
            function () {
                localStorage.removeItem('dataadded');
                this.setState({
                    successmsgmodaldata: '',
                    error: '',
                })
            }
                .bind(this), 3000
        );
    }
    //------------------------------------------------ error msg function end ------------------------------------------------

    // ------------------------------------------------main data get API start------------------------------------------------
    getallrealdata = () => {
        this.setState({
            loader: true,
        })
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/we/locationApi/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasBoxData => {
                this.setState({
                    okasBoxData,
                    actualdata: okasBoxData
                }, () => {
                    this.renderTableData();
                })
                this.setState({
                    loader: false,
                })
                // console.log('okas office location:',this.state.actualdata)
            })

    }
    //------------------------------------------------ main data get API end------------------------------------------------



    ondeleteChangekHandler = (pmids) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

        this.setState({
            confirmWindow: true
        })
        if (true) {
            this.setState({
                loader: true,
            })
            // console.log(pmids)
            let TokenValue = 'Token ' + localStorage.getItem("auth");
            var headers = {
                'Content-Type': 'application/json',
                'Authorization': TokenValue,
                'X-CSRFToken': localStorage.getItem('csrftoken')

            }
            fetch('/we/we/locationApi_detail/' + this.state.officeLocationToDelete, {
                method: "DELETE",
                headers: headers,
                // body: JSON.stringify(tt)
            })
                .then(response => {
                    response.json();
                    if (response.status == 200) {
                        this.setState({
                            successmsgmodaldata: 'dataadded',
                            successmodalstates: 'add',
                            disabledvalue: '',
                        })
                        this.getallrealdata();
                        this.oncolseClickHandler();
                        this.errormsg();
                    } else {
                        this.setState({
                            snackbarMessage: 'Office location can not deleted.',
                            snackbarActive: true,
                        })
                        // alert('Office location can not deleted.'); 
                    }
                    this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
                    this.setState({
                        loader: false,
                        confirmWindow: false,

                    })
                })
        }
    }

    handleClickpage(number) {
        this.setState({
            currentPage: number,
        });
        this.renderTableData('type1');
        this.renderTableData('pagination');
    }
    //------------------------------------------------ print main data(List view) function start----------------------------
    renderTableData = (type) => {
        if (this.state.okasBoxData.detail == 'Invalid token.') {
            localStorage.removeItem('auth');
            localStorage.removeItem('username');
            this.props.history.push('/login')
        }
        let indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
        let indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
        let currentTodos = this.state.okasBoxData.slice(indexOfFirstTodo, indexOfLastTodo);
        if (type === 'pagination') {
            let pageNumbers = [];
            for (let i = 1; i <= Math.ceil(this.state.okasBoxData.length / this.state.todosPerPage); i++) {
                pageNumbers.push(i);
            }
            let renderPageNumbers = pageNumbers.map((number, i) => {
                if ((this.state.currentPage - 3 < i + 1) && ((this.state.currentPage + 3 > i + 1 || 6 > i + 1))) {
                    return (
                        <li className={this.state.currentPage == number ? "active" : null}><a id={number} onClick={this.handleClickpage.bind(this, number)}>{number}</a></li>
                    );
                }
            });
            return renderPageNumbers;
        }
        if (type === 'type1') {
            var typee = 0;
            let xx = currentTodos.map((e, index) => {
                typee = typee + 1;
                let offloc = e.ID;
                return (
                    <tr key={index}>
                        {/* <td>{e.name}</td> */}
                        <td>{e.geo_location}</td>
                        <td>{e.phone}</td>
                        <td>{e.email}</td>
                        <td>{e.location}</td>
                        <td>{e.installed_box}</td>
                        {/* {e.installed_box == 0 ?
                            <td className={this.props.windowWidth > 760 ? "qwerty" : ""}><img src={Delete} onClick={(e) => {
                                this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

                                this.setState({
                                    confirmWindow: true,
                                    officeLocationToDelete: offloc
                                })
                            }} style={{ cursor: 'pointer' }} /></td>
                            :
                            <td className={this.props.windowWidth > 760 ? "qwerty" : ""}><img src={Delete1} /></td>
                        } */}
                        {is_allowed(
                            this.props.redux.permissions.permissions?.[0],
                            localStorage.getItem("name"),
                            "office location",
                            "delete"
                        ) && (
                                e.installed_box == 0 ? (
                                    <td className={this.props.windowWidth > 760 ? "qwerty" : ""}>
                                        <img
                                            src={Delete}
                                            onClick={(e) => {
                                                this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
                                                this.setState({
                                                    confirmWindow: true,
                                                    officeLocationToDelete: offloc
                                                });
                                            }}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </td>
                                ) : (
                                    <td className={this.props.windowWidth > 760 ? "qwerty" : ""}>
                                        <img src={Delete1} />
                                    </td>
                                )
                            )}

                    </tr>
                )
            });
            return xx;
        }
    }
    //------------------------------------------------ print main data(List view) function end--------------------------------

    //------------------------------------------------ Delete Succ msg start//------------------------------------------------
    crosssuccessfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            successmsgmodaldata: '',
        })
    }

    crosserrorfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            error: '',
            nameerror: '',
        })
    }
    ////------------------------------------------------ Delete Succ msg end//------------------------------------------------

    oncolseClickHandler = (event) => {
        this.setState({
            name: '',
            phone: '',
            email: '',
            officelocation: '',
        })
    }
    // --------------------------------------------------------open model function start----------------------------
    onopenmodel = (event) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            showmodels: 'true',
        })
        this.props.searchBarActivate(false)
        this.getcitydata();
    }
    // --------------------------------------------------------open model function end----------------------------

    // --------------------------------------------------------close model function start----------------------------
    onclosemodel = (event) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            showmodels: '',
            error: '',
            name: '',
            phone: '',
            email: '',
            indianCityWithState: '',
            nameerror: '',
            phoneerror: '',
            emailerror: '',
            indianCityWithState: '',
            officelocation: '',
            officelocationerror: '',
        })
    }
    // --------------------------------------------------------close model function End----------------------------


    // ----------------------------Submit all data in data base POST API Start--------------------------------------
    onAddClickHandler = (buttonaction) => {
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        let name = this.state.name.trim();
        let phone = this.state.phone.trim();
        let email = this.state.email.trim();
        let location = this.state.officelocation.trim() == 'Other,' ? this.state.otherlocation.trim() : this.state.officelocation.trim();
        let filterlocation = _.filter(this.state.okasBoxData, ['geo_location', location]);
        let filtername = _.filter(this.state.okasBoxData, ['name', name]);
        let tt = {
            name, phone, email, location
        };
        // console.log("🚀 Debugging location:", this.state.officelocation, this.state.otherlocation, "Final Location:", location, tt);
        if (errorText('location', location) === 'Error') {
            this.setState({ error: 'Please Select area', officelocationerror: 'errorfield' })
        }
        else if (errorText('phone', phone) === 'Error') {
            this.setState({ error: 'Enter mobile number', phoneerror: 'errorfield', })
        } else if (errorText('phone', phone) === 'Error1') {
            this.setState({ error: "Please enter Numeric Value in mobile number", phoneerror: 'errorfield', })
        } else if (errorText('phone', phone) === 'Error2') {
            this.setState({ error: "Please enter a valid mobile number of 10 digits", phoneerror: 'errorfield', })
        } else if (errorText('phone', phone) === 'Error3') {
            this.setState({ error: "Please enter a valid mobile number start from 6,7,8,9", phoneerror: 'errorfield', })
        } else if (errorText('email', email) === 'Error') {
            this.setState({ error: "Enter an email", emailerror: 'errorfield', })
        } else if (errorText('email', email) === 'Error1') {
            this.setState({ error: "Please enter a valid email example(XXXXXXX@XXXXXX.XXX)", emailerror: 'errorfield', })
        } else if (errorText('address', name) === 'Error') {
            this.setState({ error: 'Please add address', addresserror: 'errorfield', })
        } else if ((filterlocation.length == 0 && filtername.length > 0) || (filterlocation.length > 0 && filtername.length == 0) || (filterlocation.length == 0 && filtername.length == 0)) {
            this.setState({ disabledvalue: 'disabled', })
            this.setState({ loader: true, })
            fetch('/we/we/locationApi/', {
                method: "POST",
                headers: headers,
                body: JSON.stringify(tt)
            })
                .then(response => {
                    if (response.status === 403) {
                        window.location = "/login/session-timeout"
                    }
                    return response.json()
                })
                .then(response => {
                    // console.log(response)
                    if (response.message == 'success') {
                        this.setState({
                            successmsgmodaldata: 'dataadded',
                            successmodalstates: 'add',
                            disabledvalue: '',
                            officelocation: '',
                            otherlocation: '',
                            phone: '',
                            email: '',
                            name: '',
                            location: '',
                            showmodels: 'false',
                        })
                        this.getcitydata();
                        this.getallrealdata();
                        this.oncolseClickHandler();
                        this.errormsg();
                        if (buttonaction === 'add') {
                            this.onclosemodel();

                        } else if (buttonaction === 'addanother') {
                            this.onclosemodel();

                            this.onopenmodel();

                        }
                        this.setState({
                            loader: false,
                        })
                    } else {
                        this.setState({
                            snackbarMessage: response.data[0],
                            snackbarActive: true,
                            disabledvalue: '',
                        })

                    }
                    this.setState({
                        loader: false,
                    })
                })
                .then(data => { })

            // }
        } else {
            this.setState({
                error: 'Location already Exists with ' + name
            })
        }
    }
    //----------------------------------------- Submit all data in data base POST API End----------------------------------------


    //-------------------------------------------Render data after sorting Function Start----------------------------------------------
    restoreData = (data) => {
        this.setState({
            okasBoxData: data,
        })
    }
    //-----------------------------------------------Render data after sorting Function End--------------------------------------------------


    //------------------------------------------------------- sorting Function Start----------------------------------------------
    sortingFunc = (type, searchValue) => {
        if (type !== "search") {
            this.props.searchBarActivate(false)
        }
        if (type == "geo_location") {
            this.setState({
                statuson: !this.state.statuson,
                statustw: false, statusth: false, statusfo: false,
                statusfi: false, statussi: false, statusse: false,
                statusei: false, statusni: false, statuste: false,
            })
        }
        if (type == "phone") {
            this.setState({
                statustw: !this.state.statustw,
                statuson: false, statusth: false, statusfo: false,
                statusfi: false, statussi: false, statusse: false,
                statusei: false, statusni: false, statuste: false,
            })
        }
        if (type == "email") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false, statusth: !this.state.statusth,

            })
        }
        if (type == "location") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false, statusfo: !this.state.statusfo,
            })
        }
        if (type == "installed_box") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false, statusfi: !this.state.statusfi,
            })
        }
        if (this.state.sortedType !== type && type !== 'search') {
            this.setState({
                sortedType: type
            })
            Sorting(this.restoreData, type, this.state.okasBoxData);
        } else if (type === 'search') {
            type = 'search';
            Sorting(this.restoreData, type, this.state.actualdata, searchValue);
        } else {
            type = 'reverse';
            Sorting(this.restoreData, type, this.state.okasBoxData);
        }
    }

    //---------------------------------------------------------- sorting Function End--------------------------------------------------


    render() {
        return Style.it(`
        @media only screen and (max-width: 760px){
      td:nth-of-type(1):before { content: "AREA"; }
      td:nth-of-type(2):before { content: "PHONE"; }
      td:nth-of-type(3):before { content: "EMAIL"; }
      td:nth-of-type(4):before { content: "ADDRESS"; }
      td:nth-of-type(5):before { content: "BOXES"; }
      td:nth-of-type(6):before { content: "DELETE"; }
    }`,
            <div className="selfcontainer"
                style={{
                    position: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "fixed" : "absolute",
                    overflow: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "hidden" : ""
                }}

            >
                <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
                    this.setState({
                        snackbarActive: false
                    })
                }} message={this.state.snackbarMessage} />
                {this.state.loader ? <Loader /> : null}
                {this.props.redux.globalVar.searchBarShow ?
                    <div className='row searchinput'>

                        <SearchBar
                            autoFocus
                            value={this.state.searchValue}
                            onChange={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', this.state.searchValue)
                                })
                            }
                            }
                            onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
                            resetSearch={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', '')
                                })
                            }}
                        />
                    </div>
                    : ''}

                <div className="addregOkasButton">
                    {is_allowed(this.props.redux.permissions.permissions?.[0], localStorage.getItem("name"), "office location", "add") && <Box
                        component="a"
                        // href="#regiokasbox"
                        className="addregOkasButtonicon button-custom-height-size"
                        onClick={this.onopenmodel.bind(this)}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#f9f9f9",
                            color: "#94979a",
                            textTransform: "none",
                            padding: "10px 20px",
                        }}
                    >
                        <AiOutlinePlus size={30} style={{ marginRight: 8, color: "#15599F" }} />
                        <span className="hidden-xs hidden-sm button-color">ADD NEW OFFICE</span>
                    </Box>}
                    <div className="hidden-xs hidden-md  hidden-lg button-color sm-heading-btn">Add New Office</div>
                </div>
                <div className="row">
                    <h3>Dear {this.props.redux.globalVar.reUserNameStyle}, Listed below are your existing office locations</h3>
                    <h6 className="mb-3 mt-0">To add a new location click on, "Add New Office" </h6>
                    <div className={this.state.successmsgmodaldata ? 'successmsgbox' : 'successmsgbox successmsgboxnone'}  >
                        <div className="inblksuccfull"><img src={Success} /></div>
                        <div className="inblksucc1">
                            SUCCESS !
                            <a className="successmsgcross"><RxCross2 size={20} onClick={(e) => { this.crosserrorfullmsg(this) }} /></a>
                        </div>
                    </div>
                    <div className="tests">
                        <TableContainer component={Paper}>
                            <Table className={"tablecontent"}>
                                <TableHead>
                                    <TableRow>
                                        {[
                                            { key: "geo_location", label: "AREA" },
                                            { key: "phone", label: "PHONE" },
                                            { key: "email", label: "EMAIL" },
                                            { key: "location", label: "ADDRESS" },
                                            { key: "installed_box", label: "BOXES" },
                                        ].map((column) => (
                                            <TableCell sx={{ width: this.props.windowWidth > 835 ? "20%" : "20%", color: "white", fontSize: '11px' }} key={column.key} >
                                                {column.label}
                                                <IconButton style={{ float: "right", cursor: "pointer", color: 'white' }} size="small" onClick={() => this.sortingFunc(column.key, "")}>
                                                    {this.state[`status${column.key}`] ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                </IconButton>
                                            </TableCell>
                                        ))}
                                        <TableCell sx={{ width: this.props.windowWidth > 835 ? "20%" : "20%", color: "white", fontSize: '11px' }}>DELETE</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.loader ? <Loader /> : this.renderTableData("type1")}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="pull-right">
                            {this.state.todosPerPage < this.state.okasBoxData.length ?
                                <ul className="pagination pull-right paginat">
                                    <li>
                                        <span className="">Showing {(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + 1} -{this.state.currentPage * this.state.todosPerPage - this.state.okasBoxData.length < 0 ? this.state.currentPage * this.state.todosPerPage : this.state.okasBoxData.length}  of {this.state.okasBoxData.length} enteries</span>
                                    </li>
                                    <li>
                                        <a
                                            onClick={this.state.currentPage == -1 + this.state.currentPage * this.state.todosPerPage ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage - 1)
                                            }
                                            aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                            <span className="sr-only">Previous</span>
                                        </a>
                                    </li>
                                    {this.renderTableData('pagination')} in
                                    <li className="">
                                        <a className=""
                                            onClick={this.state.currentPage * this.state.todosPerPage == this.state.okasBoxData.length ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage + 1)
                                            }
                                            aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                            <span className="sr-only">Next</span>
                                        </a>
                                    </li>
                                </ul>
                                : null}
                        </div>
                    </div>
                </div>
                {this.state.showmodels ?
                    <div className="selfmodal fade in modal-dialog-centered" style={{ alignItems: "center", top: this.state.topHeightModal }} aria-hidden="false" data-backdrop="static" data-keyboard="false">
                        <div className="selfmodal-dialog"
                            style={{
                                width: this.props.windowWidth > 760 ? "50%" : "60%",
                            }}
                        >
                            <div className="selfmodal-content" >
                                <div className="modal-header">
                                    <button type="button" className="close" data-dismiss="modal" onClick={this.onclosemodel.bind(this)}>&times;</button>
                                    <h3 className="modal-title">Add New Office Location
                                    </h3>
                                    <h6>Please fill in the details to add new office location.</h6>
                                    <div className={this.state.error ? 'errormsgbox' : 'errormsgbox errormsgboxnone'}  >
                                        <div className="inblksucc"><img src={Error} /></div>
                                        <div className="inblksucc1">
                                            {this.state.error} !
                                            <a className="successmsgcross"><RxCross2 size={20} onClick={(e) => { this.crosserrorfullmsg(this) }} /></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-body modfields">
                                    <TextField
                                        label="Area"
                                        select
                                        fullWidth
                                        variant="standard"
                                        value={this.state.officelocation}
                                        onChange={(e) => {
                                            this.setState({ officelocation: e.target.value, officelocationerror: false });
                                        }}
                                        style={{ marginBottom: "10px" }}
                                        error={this.state.officelocationerror} // 👈 triggers red underline
                                        helperText={this.state.officelocationerror ? 'Please select an area' : ''} // 👈 message
                                    >
                                        {this.state.indianCityWithState.map((option, index) => (
                                            <MenuItem key={index} value={option.label}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>

                                    <br />
                                    {this.state.officelocation.trim() == 'Other,' ?
                                        <span>
                                            <TextField
                                                label="Other Location"
                                                type="text"
                                                fullWidth
                                                variant="standard" // Change to "standard" or "filled" if needed
                                                value={this.state.otherlocation}
                                                onChange={(e) => this.setState({ otherlocation: e.target.value, otherlocationerror: false })}
                                                error={Boolean(this.state.otherlocationerror)}
                                                helperText={this.state.otherlocationerror ? "Invalid location" : ""} // Custom error message
                                                style={{ marginBottom: "10px" }} // Inline styling
                                            />
                                            <br />
                                        </span> : null}
                                    <TextField
                                        label="Mobile Number"
                                        type="text"
                                        fullWidth
                                        variant="standard" // Change to "standard" or "filled" if needed
                                        value={this.state.phone}
                                        onChange={(e) => {
                                            if (e.target.value.length <= 10 && /^[0-9\b]*$/.test(e.target.value)) {
                                                this.setState({ phone: e.target.value, phoneerror: false });
                                            }
                                        }}
                                        error={Boolean(this.state.phoneerror)}
                                        helperText={this.state.phoneerror ? "Invalid phone number" : ""}
                                        style={{ marginBottom: "10px" }} // Optional styling
                                    />
                                    <br />
                                    <TextField
                                        label="Office Email"
                                        type="email"
                                        fullWidth
                                        variant="standard" // Change to "standard" or "filled" if needed
                                        value={this.state.email}
                                        onChange={(e) => {
                                            this.setState({ email: e.target.value, emailerror: false });
                                        }}
                                        error={Boolean(this.state.emailerror)}
                                        helperText={this.state.emailerror ? "Invalid email address" : ""}
                                        style={{ marginBottom: "10px" }} // Optional styling
                                    />
                                    <br />
                                    <TextField
                                        label="Address"
                                        type="text"
                                        name="address"
                                        id="address"
                                        fullWidth
                                        variant="standard"
                                        required
                                        value={this.state.name}
                                        onChange={(e) => {
                                            this.setState({ name: e.target.value, addresserror: false });
                                        }}
                                        inputProps={{
                                            maxLength: 70, // 🔒 Limit to 70 characters
                                        }}
                                        error={Boolean(this.state.addresserror)}
                                        helperText={
                                            this.state.addresserror
                                                ? "Please enter a valid address"
                                                : `${this.state.name.length}/70`
                                        }
                                        style={{ marginBottom: "10px" }}
                                    />

                                    <br />
                                    <span className="fieldmend"></span>
                                </div>
                                <div className="modal-footer align-btn-mobile" style={{ marginTop: '6%', display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                                    <div type="button" className="btn allbtn" onClick={this.onclosemodel.bind(this)}>Cancel</div>
                                    <span className="hidden-xs hidden-sm">
                                        <div disabled={this.state.disabledvalue ? this.state.disabledvalue : null} className="btn addbtn allbtn" onClick={this.onAddClickHandler.bind(this, 'addanother')}>Add Another</div>
                                    </span>
                                    <div type="submit" disabled={this.state.disabledvalue ? this.state.disabledvalue : null} className="btn btn-primary allbtn" onClick={this.onAddClickHandler.bind(this, 'add')}>Add</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ''}
                {this.state.confirmWindow ? <div className="selfmodal fade in modal-dialog-centered" aria-hidden="false" data-backdrop="static" data-keyboard="false">
                    <div className="selfmodal-dialog " style={{ width: "50%" }}>
                        <div className="selfmodal-content ">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" onClick={this.confirmWindowClose.bind(this)}>&times;</button>
                                <h4 className="modal-title h3 text-center">Delete confirmation</h4>
                            </div>
                            <div className="modal-body modfields">
                                <span className="fa " >Are you sure you want to proceed with deletion?</span>
                            </div>
                            <div className="modal-footer text-center  align-btn-mobile">
                                <button type="button" className="btn allbtn" onClick={this.confirmWindowClose.bind(this)}>Cancel</button>
                                <button type="submit" disabled={this.state.disabledvalue ? this.state.disabledvalue : null} className="btn btn-primary allbtn" onClick={this.ondeleteChangekHandler.bind(this)}>Delete</button>
                            </div>
                        </div>
                    </div>
                </div> : null}
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        redux: state,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        successBarActivate: (data) => dispatch({ type: ActionTypes.SUCCESSBAR, data: data }),
        backgroundScrollStop: (data) => dispatch({ type: ActionTypes.SCROLLSTOP, data: data }),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(OfficeLocation);
